export const removeAcentos = word => {

    const replacementMap = {
        "á":'a',
        "é":'e',
        "í":'i',
        "ó":'o',
        "ú":'u',
        "Á":"A",
        "É":"E",
        "Í":"I",
        "Ó":"O",
        "Ú":"U"
    }
    return word? Object.keys(replacementMap).reduce((prev,curr) => {
        return prev.replaceAll(curr, replacementMap[curr]);
    },word):'';
};